import {Injectable} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CatalogService {
  constructor(
    private translate: TranslateService
  ) { }

  getFeatureTranslation(featureName: string): Observable<string> {
    let key = "common.features." + featureName;
    return this.translate.get(key).pipe(
      map(translation => translation === key ? featureName : translation)
    );
  }

  getFeatureHintTranslation(featureName: string): Observable<string>{
    let key = "common.hints." + featureName;
    return this.translate.get(key).pipe(
      map(translation => translation === key ? featureName : translation)
    );
  }

  getSideLetter(side: LensSide) {
    if(side === "RIGHT") {
      return "R"
    } else if(side === "LEFT") {
      return "L"
    } else {
      return null;
    }
  }

}

export type LensSide = "RIGHT" | "LEFT";
